const prefix = '/criterias'

export const CRITERIA_EDIT_URL = (id) => `${prefix}/${id}/edit`
export const CRITERIA_CREATE_URL = () => `${prefix}/new`
export const CRITERIA_INDEX_URL = () => `${prefix}`
